// Shared palette, formatters and base options for the dashboard charts
// (chart.js through primereact/chart).

export const CHART_COLORS = {
  ordenado: "#252e3f",
  facturado: "#2f7ed8",
  contabilizado: "#1aa37a",
  pendiente: "#f0a202",
  diferencia: "#e0524a",
  neutral: "#94a3b8",
};

// Categorical palette for doughnuts / multi-series bars
export const CHART_PALETTE = [
  "#2f7ed8",
  "#1aa37a",
  "#f0a202",
  "#e0524a",
  "#7c5cc4",
  "#16a2b8",
  "#d9489b",
  "#6b8e23",
  "#94a3b8",
  "#252e3f",
];

export const CHART_TEXT_COLOR = "#5b6474";
export const CHART_GRID_COLOR = "rgba(148, 163, 184, 0.25)";

const compactFormatter = new Intl.NumberFormat("es-CL", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const integerFormatter = new Intl.NumberFormat("es-CL", {
  maximumFractionDigits: 0,
});

export const formatMoney = (value: number | null | undefined): string =>
  `$ ${integerFormatter.format(Number(value) || 0)}`;

export const formatMoneyCompact = (value: number | null | undefined): string =>
  `$ ${compactFormatter.format(Number(value) || 0)}`;

export const formatNumber = (value: number | null | undefined): string =>
  integerFormatter.format(Number(value) || 0);

export const formatPercent = (value: number | null | undefined): string =>
  `${(Number(value) || 0).toLocaleString("es-CL", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} %`;

export const withAlpha = (hex: string, alpha: number): string => {
  const clean = hex.replace("#", "");
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const baseLegend = {
  position: "bottom" as const,
  labels: {
    color: CHART_TEXT_COLOR,
    usePointStyle: true,
    boxWidth: 8,
    padding: 14,
  },
};

export const baseTooltip = {
  backgroundColor: "rgba(37, 46, 63, 0.95)",
  padding: 10,
  cornerRadius: 6,
  titleFont: { weight: "bold" as const },
};
